import { Loans } from './liabilities-loans.model';
import { Mortgages } from './liabilities-mortgages.model';

export class Liabilities {
    asOfDate: Date;
    asOfDateString: string;
    availableCredit: number;
    creditLimit: number;
    currentBalance: number;
    loans: Loans;
    mortgages: Mortgages;
    returnCode: string;
}
